import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery'
import ManagePage from '../../views/ManagePage/';
const GLOBAL = require('../../Globals');

class AllUser extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			startyear : '',
			startmonth : '',
			endyear : '',
			endmonth : '',
			yearstatus : '',
			_message : '',
			value : '',
			alertClass :'',
			_redirect : '',
			posts : []
		}
		/** bind function **/
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** reset the form **/
	onClick(e){
		
		document.getElementById("acyearform").reset();
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
				$("#showLoader").show();
			PostData('user/deleteuser',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'User Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		
		this.state.endyear = $("#eyear").val();
		
		if(this.state.startyear && this.state.startmonth && this.state.endyear && this.state.endmonth ){
			
			PostData('academic/add',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Academic Year Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("acyearform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	/** this function will be call when page loading **/
	componentDidMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('user/getusers').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
				
			}
			
		});
	}
	
	/** pass id to update value **/
	onUpdate(dt){
		
		this.state.id = dt;
		this.setState({_redirect: true});
		
	}
	
  render() {
	
	/** Redirect to update page **/
	if(this.state._redirect){
		  
		return (<Redirect to={'/users/edituser/'+this.state.id} />);

	}
	
    return (
		<div>
		  <ManagePage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="12">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
				   <Card>
					<CardHeader>
						<strong>All Users</strong>
					</CardHeader>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Name</th>
								<th>Sex</th>
								<th>Mobile</th>
								<th>Email</th>
								<th>Role</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.posts.map((item,i) =>
							 
								<tr key = {item}>
									<td>{i+1}</td>
									<td>{item.name}</td>
									<td className="txt-capital">{item.gender}</td>
									<td>{item.mobile}</td>
									<td>{item.email}</td>
									<td className="txt-capital">{item.role}</td>
									<td>
										<button name="edituser" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
										&nbsp;&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>
				  
							 )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default AllUser;


// WEBPACK FOOTER //
// ./src/users/AllUser/AllUser.js